import { render, staticRenderFns } from "./TiptapToolbar.vue?vue&type=template&id=9c6e33ac&scoped=true"
import script from "./TiptapToolbar.vue?vue&type=script&lang=ts"
export * from "./TiptapToolbar.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./TiptapToolbar.vue?vue&type=style&index=0&id=9c6e33ac&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./TiptapToolbar.vue?vue&type=style&index=1&id=9c6e33ac&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9c6e33ac",
  null
  ,true
)

export default component.exports